import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Input } from "antd";
import Page from "../../../common/components/Page";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import useLogin from "./useLogin";
import { allValidation } from "../../../common/constants/Helpers";

const Login = () => {
  const { loginForm, isLoginLoading, handleLoginClick, handleOnCancelClick } = useLogin();

  return (
    <Page>
      <Page.Title icon="user" title="Account Login" />
      <Page.Content>
        <Form layout="vertical" form={loginForm}>
          <Col xl={8} lg={10} md={24} sm={24} xs={24}>
            <BannerCard title="Login Details">
              <Row gutter={[12, 12]}>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Form.Item label="Login ID" name="USERNAME" rules={allValidation}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Form.Item label="Password" name="PASSWORD" rules={allValidation}>
                    <Input.Password />
                  </Form.Item>
                </Col>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Link to="/register">Register New Account</Link>
                </Col>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Link to="/recover">Recover/Reset Password</Link>
                </Col>
                <Col>
                  <CleanButton icon="check" onClick={handleLoginClick} loading={isLoginLoading}>
                    Login
                  </CleanButton>
                </Col>
                <Col>
                  <CleanButton icon="times" onClick={handleOnCancelClick}>
                    Cancel
                  </CleanButton>
                </Col>
              </Row>
            </BannerCard>
          </Col>
        </Form>
      </Page.Content>
    </Page>
  );
};

export default Login;
